import { Injectable } from '@angular/core';
import { browserHelper } from 'lib/helpers/browser-helper.class';
import { PlatformService } from 'lib/platform/index.js';
import { ScreenService } from 'lib/screen';

@Injectable({
	providedIn: 'root'
})
export class PwaService {
	constructor(private readonly platformService: PlatformService, private readonly screenService: ScreenService) {}

	isInstallSupportedOnCurrentDevice(): boolean {
		const currentScreen = this.screenService.currentScreen();

		if (currentScreen.userAgent) {
			const browser = browserHelper.getBrowserInfo(currentScreen.userAgent);

			if (browser) {
				if (browser.browserName?.includes('chrome')) {
					// chrome is supported
					return true;
				}

				if (browser.platform === 'mobile' || browser.platform === 'tablet') {
					return true;
				}
			}
		}

		// only mobile and tablet are supported
		if (currentScreen.platform === 'mobile' || currentScreen.platform === 'tablet') {
			return true;
		}

		return false;
	}

	isInstalled(): boolean {
		if (this.platformService.isServer) {
			return false;
		}

		if (window.matchMedia('(display-mode: standalone)').matches) {
			return true;
		}
		return false;
	}
}
